import { EyeOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React, { useEffect, useState } from "react";
import employeeService from "Services/EmployeeServices/EmployeesService";
import { useNavigate } from "react-router-dom";

export const useEmployee = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [employeeDetail, setEmployeeDetail] = useState(null);
   const [myDetail, setMyDetail] = useState(null);
  const [compensations, setCompensations] = useState([]);
  const [loadingCompensation, setLoadingCompensation] = useState(false);
  const [compensationsLoaded, setCompensationsLoaded] = useState(false);
  const [employments, setEmployments] = useState([]);
  const [loadingEemployments, setLoadingEmployments] = useState(false);
  const [employmentsLoaded, setEmploymentsLoaded] = useState(false);
  const navigate = useNavigate();

  const fetchEmployees = async () => {
    try {
      setLoading(true);

      const data = await employeeService.getEmployees();
      setEmployees(data);
    } catch (error) {
      console.error("Error in fetching employees", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchEmployeeDetail = async (employeeId) => {
    try {
      setLoadingDetail(true);
      const data = await employeeService.getEmployeeDetail(employeeId);
      setEmployeeDetail(data);
    } catch (error) {
      console.error(" Error in geting employee detail", error);
    } finally {
      setLoadingDetail(false);
    }
  };

   const fetchMyDetail = async () => {
    try {
      setLoadingDetail(true);
      const data = await employeeService.getMyDetail();
      setMyDetail(data);
    } catch (error) {
      console.error(" Error in geting employee detail", error);
    } finally {
      setLoadingDetail(false);
    }
  };

  useEffect(() => {
    fetchEmployees();
    
  }, []);

  const resetEmployeeTabs = () => {
  setCompensations([]);
  setEmployments([]);


  setCompensationsLoaded(false);
  setEmploymentsLoaded(false);
};

  const fetchCompensations = async (employeeId) => {
    try {
      setLoadingCompensation(true);
      
      const data = await employeeService.getCompensations(employeeId);
      setCompensations(data);
      setCompensationsLoaded(true);
    } catch (error) {
      console.error(" Error in geting compensations detail", error);
    } finally {
      setLoadingCompensation(false);
    }
  };

  const fetchEmployments = async (employeeId) => {
    try {
      setLoadingEmployments(true);
      const data = await employeeService.getEmployement(employeeId);
      setEmployments(data);
      setEmploymentsLoaded(true);
    } catch (error) {
      console.error(" Error in geting Employments detail", error);
    } finally {
      setLoadingEmployments(false);
    }
  };

  

  const columns = [
    {
      title: "Employee",
      dataIndex: "employee",
      key: "employee",
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: "bold" }}>{record.fullName}</div>
          <div style={{ color: "#888" }}>
            {record.publicId} - {record.email}
          </div>
        </div>
      ),
    },
    {
      title: "Designation",
      dataIndex: "designationName",
      key: "designationName",
    },
    {
      title: "Job Title",
      dataIndex: "jobTitleName",
      key: "jobTitleName",
      
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (value) =>
        value
          ? new Date(value).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
          : "Null",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <>
          <Button
            icon={<EyeOutlined />}
            style={{ marginRight: "8px" }}
            onClick={() => navigate(`/employeedashboard/employeeDetail/${record.id}`)
            }
          />
        </>
      ),
    },
  ];

  return {
    loading,
    employees,
    columns,

    employeeDetail,
    loadingDetail,
    fetchEmployeeDetail,

    compensations,
    loadingCompensation,
    fetchCompensations,
    compensationsLoaded,

    employments,
    loadingEemployments,
    employmentsLoaded,
    fetchEmployments,

    resetEmployeeTabs,
    fetchMyDetail,
    myDetail
  };
};
